import { IConnectContact } from '@epicuro-next/data/connect';
import { ConnectionStatus } from '@epicuro-next/models/users';
import { createAction, props } from '@ngrx/store';

export const loadUserContactsState = createAction(
  '[Connect] Load the user contacts state',
);

export const loadUserContactsStateSuccess = createAction(
  '[Connect] Load the user contacts state success',
  props<{ contacts: IConnectContact[] }>(),
);
export const loadUserContactsStateFailure = createAction(
  '[Connect] Load the user contacts state failure',
);

export const setContactConnectionStatus = createAction(
  '[Connect] Set user contact connection status',
  props<{ userId: string; status: ConnectionStatus }>(),
);

export const setCurrentUserContactState = createAction(
  '[Connect] Set user current contact state',
  props<{ contact: IConnectContact }>(),
);
